import { publicRuntimeConfig } from '@utils/publicRuntimeConfig';

const { appName } = publicRuntimeConfig as any;
export const appConfig = {
  appName,
  isMeater: appName === 'meater',
  isTraeger: appName === 'traeger',
};
